module.exports = __webpack_public_path__ + "static/media/vector-4967.0dabe1ec.svg";